"use client";

import { PlatformDataEvents } from "../PlatformDataEvents";
import type { UserData } from "@/lib/casper/createUserData";

type GetUserTrackingDataProps = {
  userData: UserData | null;
  isLoggedIn: boolean;
  event?: PlatformDataEvents;
};

export const getUserTrackingData = ({
  userData,
  isLoggedIn,
  event,
}: GetUserTrackingDataProps) => {
  const isVisitEvent = event === PlatformDataEvents.VISIT;

  const trackingData = {
    currency: "EUR",
    deviceType: userData?.deviceType || "desktop",
    isLogged: isLoggedIn ? "Yes" : "No",
    uid: userData?.userUid || "",
    sessionId: userData?.sessionId || "",
    isBot: userData?.isBot || false,
  };

  if (isVisitEvent && typeof window !== "undefined") {
    const dqData = userData?.casperResponseProperties?.dq || null;
    return { ...trackingData, dq: dqData };
  }

  return trackingData;
};
